import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { Store, Select } from '@ngxs/store';
import { VenueManagementState } from '@moduurnv2/libs-orderingapp/src/core';
import { Observable } from 'rxjs';
import { ModalService } from '@moduurnv2/web/features/ui/components/modal/modal.service';
import { WJPersonCountComponent } from '../wj-app/features/wj-home/wj-person-count/wj-person-count.component';
import { WJOrdersInProgressComponent } from '../wj-app/features/wj-home/wj-orders-in-progress/wj-orders-in-progress.component';
@Injectable()
export class WJPersonPerTableGuardService implements CanActivate {
  personPerTableEntered: Boolean = true;
  CustomerNoTable: Number;
  PersonNumber;
  @Select(VenueManagementState.getCustomersPerTable) customerNoPerTable$: Observable<any>;
  @Select(VenueManagementState.getInProgressStatus) inProgressStatus$: Observable<any>;
  guestsInActiveOrders: number = 0;

  constructor(
    public store: Store,
    public router: Router,
    private modal: ModalService
  ) {
    this.customerNoPerTable$.subscribe((persons) => {
      if (persons) {
        this.personPerTableEntered = true;
      } else {
        this.personPerTableEntered = false;
      }
    });

    this.inProgressStatus$.subscribe((status:any) => {
      if (status?.guestsInActiveOrders >=0) {
        this.guestsInActiveOrders = status.guestsInActiveOrders;
      }
    });
  }

  customerNoPerTable: any = {};
  _modalClose: any = null;
  set modalClose(modalRef: any) {
    this._modalClose = (data) => {
      this.modal.closeComponentModal(modalRef, data);
    };
  }
  canActivate(): any {
    const selectedDelivery = this.store.selectSnapshot(
      (app) => app && app.delivery && app.delivery.selectedDelivery
    );
    const selectedTable = this.store.selectSnapshot(
      (app) => app && app.delivery && app.venuemanagement.selectedLoungeTable
    );
    const totalPersonPerTable = this.store.selectSnapshot(
      (app) => app && app.venuemanagement && app.venuemanagement.totalPersonPerTable
    );

    if(!this.personPerTableEntered){
      this.personPerTableEntered = totalPersonPerTable && totalPersonPerTable.count ? true : false
    }

    const venues = this.store.selectSnapshot(
      (app) => app && app.venuemanagement && app.venuemanagement.venues
    );
    //find menu config, a bit clunky, cause I'm not adding a field...but hey at least I'm storing the user numbers in the db! and not code.
    //Required Table Format in MBO Venue Management is TABLE_NUMBER-MAX_GUESTS
    let maxOrderGuests = 1 //just in case we find nothing
    let venueNameStarting = (selectedDelivery.textCode == "DELIVERYTYPE08") ? selectedTable.name : "pickup"
    const selectedTableConfig = venues.find((venue) => venue.name && venue.name.startsWith(venueNameStarting)) 
  
    if (selectedTableConfig?.name.includes("-")) {
        const tableConfig = selectedTableConfig.name.split("-")
        maxOrderGuests = tableConfig[1] - this.guestsInActiveOrders
    }

    //if we've already got orders in progress, then show a we're working on it.  screen with a button to clear the person count and start people again.
    if (maxOrderGuests <= 0) {
      this.modal.showSmallFormModal(WJOrdersInProgressComponent, 
        {data: {maxGuests:maxOrderGuests, pickupOrder: (selectedDelivery.textCode == 'DELIVERYTYPE02'), guestsInActiveOrders: this.guestsInActiveOrders}});
      return false
    }


    if (this.personPerTableEntered && selectedTable?.guestCount > 0) {
      return true;
    } else {
      this.modal.showSmallFormModal(WJPersonCountComponent, {data: {maxGuests:maxOrderGuests, pickupOrder: (selectedDelivery.textCode == 'DELIVERYTYPE02'), guestsInActiveOrders: this.guestsInActiveOrders}});
      return false;
    }
  }
}
